











































































































import { eventCodeByName, EventsNames } from "@/analytics";
import { Vue, Component } from "vue-property-decorator";
import amplitude from "amplitude-js";
import HeaderMenuList from "@/components/HeaderMenuList/HeaderMenuList.vue";

@Component({
  components: {
    HeaderMenuList
  }
})
export default class HeaderMainMenu extends Vue {
  public logNavigationEvent(page: string) {
    let event = "";

    switch (page) {
      case "teachers":
        event = `${eventCodeByName(EventsNames.UserClicksTeachersInMenu)} ${
          EventsNames.UserClicksTeachersInMenu
        }`;
        break;
      case "students":
        event = `${eventCodeByName(EventsNames.UserClicksStudentsInMenu)} ${
          EventsNames.UserClicksStudentsInMenu
        }`;
        break;
      case "classes":
        event = `${eventCodeByName(EventsNames.UserClicksClassesInMenu)} ${
          EventsNames.UserClicksClassesInMenu
        }`;
        break;
      case "reports":
        event = `${eventCodeByName(EventsNames.UserClicksReportsInMenu)} ${
          EventsNames.UserClicksReportsInMenu
        }`;
        break;
      case "lessons":
        event = `${eventCodeByName(EventsNames.UserClicksLessonsInMenu)} ${
          EventsNames.UserClicksLessonsInMenu
        }`;
        break;
      case "grammar-to-go":
        event = `${eventCodeByName(EventsNames.UserClicksGrammarToGoInMenu)} ${
          EventsNames.UserClicksGrammarToGoInMenu
        }`;
        break;
      case "knowledge-base":
        event = `${eventCodeByName(EventsNames.UserClicksGrammarToGoInMenu)} ${
          EventsNames.UserClicksGrammarToGoInMenu
        }`;
        break;
      default:
        break;
    }

    amplitude.getInstance().logEvent(event);
  }
}
